<script setup lang="ts">
</script>

<template>
  <div class="min-h-screen flex items-center justify-center py-4">
    <div class="w-full max-w-4xl ">
      <div class="border border-[#DFE3E8] rounded-2xl overflow-hidden shadow-md">
        <RouterView v-slot="{ Component, route }">
          <component :is="Component" :key="route.fullPath" />
        </RouterView>
      </div>
    </div>
  </div>
</template>

<style scoped>
.min-h-screen {
	background-image: url('@/assets/background-cover.png');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
</style>
